export const singularDateUnit = (unit) => {
  switch (unit) {
    case 'days':
      return 'day';
    case 'weeks':
      return 'week';
    case 'months':
      return 'month';
    default:
      break;
  };
};

export default singularDateUnit;
